import { RadioGroup } from '@material-ui/core'

import IconRadioButton from './IconRadioButton'
import { IconRadioButtonOption } from './IconRadioButton'

type IconRadioGroupProps = {
  options: IconRadioButtonOption[]
  onSelect: (value: string) => void
}

const IconRadioGroup = ({ options, onSelect }: IconRadioGroupProps) => {
  return (
    <RadioGroup
      onChange={(e) => {
        const selectedType = e.target.value
        onSelect(selectedType)
      }}
    >
      {options.map((option, idx) => {
        return (
          <IconRadioButton
            key={idx}
            option={option}
          />
        )
      })}
    </RadioGroup>
  )
}

export default IconRadioGroup
